import * as FileSaver from 'file-saver';
import * as Xlsx from 'xlsx';

import { Injectable } from '@angular/core';

export type ExcelSheet = { sheetName: string; data: string[][] };

@Injectable({
  providedIn: 'root',
})
export class XlsxService {
  // 参考 https://github.com/primefaces/primeng/blob/master/src/app/showcase/components/table/tableexportdemo.ts

  exportExcel(excelSheets: ExcelSheet[], fileName: string): void {
    const workbook: Xlsx.WorkBook = { Sheets: {}, SheetNames: [] };

    for (const excelSheet of excelSheets) {
      const worksheet = Xlsx.utils.aoa_to_sheet(excelSheet.data);
      workbook.Sheets[excelSheet.sheetName] = worksheet;
      workbook.SheetNames.push(excelSheet.sheetName); // sheetNameは31文字まで
    }

    const excelBuffer: ArrayBuffer = Xlsx.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.save(excelBuffer, fileName);
  }

  save(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }
}
